// Touch switch control â€” 1 / 2 / 4 gang. Publishes `<output>-<state>` and
// reflects live status from `<uno>/client` ('1-1' for 1-gang, '0,1,0,1' multi).

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Stack, Typography, Switch, IconButton, Box, Button } from '@mui/material';
import ScheduleIcon from '@mui/icons-material/Schedule';
import DeviceShell from '../../components/DeviceShell';
import { useApp } from '../../../../core/state/AppContext';
import { useDeviceStatus } from '../../../../core/mqtt/useDeviceStatus';
import { publishCommand } from '../../../../core/utils/deviceController';

function parseStates(status, gangs) {
  if (!status) return Array(gangs).fill(false);
  if (gangs === 1) {
    const parts = status.split('-');
    return [parts[parts.length - 1] !== '0'];
  }
  const parts = status.split(',');
  return Array.from({ length: gangs }, (_, i) => parts[i] === '1');
}

export default function TouchScreen({ device, outputs, gangs, initialStatus = '' }) {
  const { userId } = useApp();
  const navigate = useNavigate();
  const uno = device.UniqueNumber;
  const [status] = useDeviceStatus(uno, initialStatus);
  const [states, setStates] = useState(() => Array(gangs).fill(false));

  useEffect(() => {
    if (status) setStates(parseStates(status, gangs));
  }, [status, gangs]);

  const toggle = (index) => {
    const next = !states[index];
    const updated = [...states];
    updated[index] = next;
    setStates(updated);
    publishCommand(uno, `${index + 1}-${next ? 1 : 0}`, userId);
  };

  const setAll = (on) => {
    setStates(Array(gangs).fill(on));
    publishCommand(uno, on ? 'allon' : 'alloff', userId);
  };

  const outName = (i) => {
    const o = outputs.find((x) => Number(x.Output) === i + 1);
    return (o && o.OutputName) || `Switch ${i + 1}`;
  };

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Stack spacing={2}>
        {gangs > 1 && (
          <Stack direction="row" spacing={1.5}>
            <Button variant="contained" fullWidth onClick={() => setAll(true)}>All On</Button>
            <Button variant="outlined" fullWidth onClick={() => setAll(false)}>All Off</Button>
          </Stack>
        )}
        {Array.from({ length: gangs }, (_, i) => (
          <Card key={i} sx={{ bgcolor: 'primary.main', p: 2, borderRadius: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography sx={{ flex: 1, color: 'primary.contrastText' }} fontWeight={600}>
                {outName(i)}
              </Typography>
              <IconButton
                size="small"
                sx={{ color: 'primary.contrastText' }}
                onClick={() => navigate(`/schedule/${uno}/${i + 1}`, { state: { deviceId: device.DeviceID, name: outName(i) } })}
              >
                <ScheduleIcon />
              </IconButton>
              <Switch checked={states[i]} onChange={() => toggle(i)} />
            </Box>
          </Card>
        ))}
      </Stack>
    </DeviceShell>
  );
}
